// import React, { InputHTMLAttributes } from 'react'
// import { Checkmark, Container, CheckboxStyled } from './Checkbox.style'

// interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
//   top: string
// }

// export function Checkbox({ top, ...props }: CheckboxProps) {
//   return (
//     <Container className="container">
//       <CheckboxStyled {...props} type="checkbox" />
//       <Checkmark top={top} className="checkmark" />
//     </Container>
//   )
// }

import React, { InputHTMLAttributes } from 'react'
import { Checkmark, Container, CheckboxStyled } from './Checkbox.style'

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  top: string
  background?: boolean
  check?: string
  bloqueado?: string
}

export function Checkbox({
  top,
  background,
  check,
  bloqueado,
  ...props
}: CheckboxProps) {
  return (
    <Container background={background} check={check} className="container">
      <CheckboxStyled {...props} type="checkbox" />
      <Checkmark top={top} bloqueado={bloqueado} className="checkmark" />
    </Container>
  )
}
